import {excisting_types as rev_excisting_types, new_types as rev_new_types} from './types/revenues';
import {excisting_types as comp_excisting_types, new_types as comp_new_types} from './types/companies';
import {excisting_types as deposits_excisting_types, new_types as deposits_new_types} from './types/deposits';
import {excisting_types as mobile_properties_excisting_types, new_types as mobile_properties_new_types} from './types/mobile_properties';
import {excisting_types as properties_excisting_types, new_types as properties_new_types} from './types/properties';
import {excisting_types as stocks_excisting_types, new_types as stocks_new_types} from './types/stocks';

export const filtersMixin = { 
  filters: {
    revenuesValue (value) {
      const result = rev_new_types[rev_excisting_types.indexOf(value)];
      if(!result) {
        return value;
      }
      return rev_new_types[rev_excisting_types.indexOf(value)]
    },
    companiesValue (value) {
      const result = comp_new_types[comp_excisting_types.indexOf(value)];
      if(!result) {
        return value;
      }
      return comp_new_types[comp_excisting_types.indexOf(value)]
    },
    depositsValue (value) {
      const result = deposits_new_types[deposits_excisting_types.indexOf(value)];
      if(!result) {
        return value;
      }
      return deposits_new_types[deposits_excisting_types.indexOf(value)]
    },
    mobilePropertiesValue (value) {
      const result = mobile_properties_new_types[mobile_properties_excisting_types.indexOf(value)];
      if(!result) {
        return value;
      }
      return mobile_properties_new_types[mobile_properties_excisting_types.indexOf(value)]
    },
    propertiesValue (value) {
      const result = properties_new_types[properties_excisting_types.indexOf(value)];
      if(!result) {
        return value;
      }
      return properties_new_types[properties_excisting_types.indexOf(value)]
    },
    stocksValue (value) {
      const result = stocks_new_types[stocks_excisting_types.indexOf(value)];
      if(!result) {
        return value;
      }
      return stocks_new_types[stocks_excisting_types.indexOf(value)]
    },
  }
}